<template>
  <span v-if="link === undefined"></span>
  <a v-else :href="link"><slot></slot></a>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      required: true,
    },
  },
};
</script>
